import { type ReactNode, useState } from 'react';

import clsx from 'clsx';

import { type Tab, Tabs } from '@/components/common/Tabs';
import { type WithClassName } from '@/types/react';

import styles from './AdaptiveContentTabs.module.scss';

export type AdaptiveContentTab<TabKey extends string> = WithClassName &
  Tab<TabKey> & {
    content: ReactNode;
  };

type AdaptiveContentTabsProps<TabKey extends string> = WithClassName & {
  itemClassName?: string;
  tabs: AdaptiveContentTab<TabKey>[];
};

export const AdaptiveContentTabs = <TabKey extends string>(props: AdaptiveContentTabsProps<TabKey>) => {
  const { className, itemClassName, tabs } = props;

  const [selectedTabKey, setSelectedTabKey] = useState(tabs.at(0)?.key ?? null);

  return (
    <div className={clsx(styles.root, className)}>
      <Tabs className={styles.tabs} tabs={tabs} selectedTabKey={selectedTabKey} setSelectedTabKey={setSelectedTabKey} />

      {tabs.map(({ key, className, content }) => (
        <div
          key={key}
          className={clsx(
            styles.tabContent,
            {
              [styles.isHidden]: key !== selectedTabKey,
            },
            itemClassName,
            className
          )}
        >
          {content}
        </div>
      ))}
    </div>
  );
};
